<template>
  <div
    class="input-list-card"
    :class="{borderTop:borderTop,'border-bottom':hasBorderBottom}"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: "InputListCard",
  props: {
    borderTop: {
      type: Boolean,
      default: false,
    },
    hasBorderBottom: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/input-list-card";
</style>